import { render, staticRenderFns } from "./ArticleImages.vue?vue&type=template&id=6e410058&"
import script from "./ArticleImages.vue?vue&type=script&lang=ts&"
export * from "./ArticleImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports